module.exports = __webpack_public_path__ + "static/img/tp4-7-dark-gray.6609119.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/banners/tp4-7-dark-gray.svg
// module id = 194g
// module chunks = 88